import { Helmet } from 'react-helmet-async';

// Single source of truth for the page-title suffix.
// NOTE: keep in sync with scripts/gen-route-html.js (Node build script
// cannot import this ESM module, so the suffix is duplicated there).
export const TITLE_SUFFIX = '2026柔佛州选 - 東方網 馬來西亞東方日報';

export const buildTitle = (prefix) =>
  prefix ? `${prefix} - ${TITLE_SUFFIX}` : TITLE_SUFFIX;

// Stable @id anchors for the site-level JSON-LD nodes declared statically in
// public/index.html (NewsMediaOrganization + WebSite). Per-page nodes link
// back to these so the structured data forms one connected graph.
const ORG_ID = 'https://www.orientaldaily.com.my/#organization';
const WEBSITE_ID = 'https://www.orientaldaily.com.my/#ge16-website';

// Per-route <title> / og:title plus per-page structured data
// (WebPage + BreadcrumbList). Pass `prefix` for the page-specific part;
// omit it on the home page to render the suffix alone.
const PageMeta = ({ prefix }) => {
  const title = buildTitle(prefix);

  const origin =
    typeof window !== 'undefined' ? window.location.origin : '';
  const url =
    typeof window !== 'undefined' ? window.location.href : `${origin}/`;

  const breadcrumb = [
    { '@type': 'ListItem', position: 1, name: '首页', item: `${origin}/` },
  ];
  if (prefix) {
    breadcrumb.push({
      '@type': 'ListItem',
      position: 2,
      name: prefix,
      item: url,
    });
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': url,
        url,
        name: title,
        inLanguage: 'zh-Hans',
        isPartOf: { '@id': WEBSITE_ID },
        publisher: { '@id': ORG_ID },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `${url}#breadcrumb`,
        itemListElement: breadcrumb,
      },
    ],
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={title} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default PageMeta;
